import React from 'react';

import * as S from './BannerCard.styles';

const BannerCard = ({text}) => {
  return (
    <S.BannerContainer>
      <S.BannerLeftWrap>
        <S.TextWrap>{text}</S.TextWrap>
      </S.BannerLeftWrap>
    </S.BannerContainer>
  );
};

export default BannerCard;
